






























































































































































































import axios from 'axios';
import * as math from 'mathjs';
import Component from 'vue-class-component';

import { Contact, ReconciliationStatus, Transaction, Wallet } from '@/api-svc-types';
import TooltipSelect from '@/components/tooltip/TooltipSelect.vue';
import { RegisterQuery } from '@/queries/registerQuery';
import { isDefined } from '@/utils/guards';
import { formatRegisterDateTime } from '@/utils/registerDateFormat';

import { baConfig } from '../../config';
import { BaseVue } from '../BaseVue';
import CreateManualTransaction from '../components/transactions/CreateManualTransaction.vue';
import SaveInline from '../components/transactions/SaveInline.vue';
import UiButton from '../components/ui/UiButton.vue';
import UiDatePicker from '../components/ui/UiDatePicker.vue';
import UiDropdown from '../components/ui/UiDropdown.vue';
import UiLoading from '../components/ui/UiLoading.vue';
import UiRadioGroup from '../components/ui/UiRadioGroup.vue';
import UiSelect from '../components/ui/UiSelect.vue';
import UiSelect2 from '../components/ui/UiSelect2.vue';
import UiTabs2 from '../components/ui/UiTabs2.vue';
import UiTextEdit from '../components/ui/UiTextEdit.vue';
import UiToggle from '../components/ui/UiToggle.vue';
import UiTooltip from '../components/ui/UiTooltip.vue';
import { WalletsQuery } from '../queries/transactionsPageQuery';

enum RegisterTab {
  Register = 'register',
  Variance = 'variance',
}

@Component({
  components: {
    SaveInline,
    UiButton,
    UiDropdown,
    UiTooltip,
    UiLoading,
    UiSelect,
    UiRadioGroup,
    UiTextEdit,
    UiDatePicker,
    CreateManualTransaction,
    TooltipSelect,
    UiTabs2,
    UiSelect2,
    UiToggle,
  },
  apollo: {
    $client: 'rptApolloClient',
    wallets: {
      query: WalletsQuery,
      variables() {
        if (this.$store.state.currentOrg) {
          return {
            orgId: this.$store.state.currentOrg.id,
          };
        } else {
          return false;
        }
      },
      loadingKey: 'isLoading',
    },
  },
})
export default class Register extends BaseVue {
  public wallets: Wallet[] = [];
  public register?: any = null;
  public maxDate = new Date().toISOString().substring(0, 10);
  public registerTab: RegisterTab = RegisterTab.Register;

  public get headers() {
    return Object.values(this.columns).map((x) => x.heading);
  }

  public activeTabClass = ' tw-border-t-2 tw-border-l-2 tw-border-r-2 tw-border-grey tw-rounded-t-md';

  public columns = {
    date: { heading: 'Date', size: 100 / 5 },
    txn: { heading: 'Txn', size: 100 / 5 },
    ticker: { heading: 'Ticker', size: 100 / 5 },
    amount: { heading: 'Amount', size: 100 / 5 },
    balance: { heading: 'Balance', size: 100 / 5 },
  };

  public allSelected = false;
  public isLoading = 0;
  public showFilters = false;
  public skipQuery = true;
  public useFiat = false; // false = coin, true = fiat
  public endDate = new Date().toISOString().substring(0, 10);
  public startDate = '';
  public currentPage = 1;

  public vars = {
    filter: {
      categorizationFilter: 'All',
      reconciliationFilter: 'Unreconciled',
      ignoreFilter: 'Unignored',
      walletId: 'All',
      searchTokens: undefined as string[] | undefined,
      errored: undefined as boolean | undefined,
      pivotDate: new Date().toISOString().substring(0, 10),
    },
    limit: '10',
    paginationToken: undefined as string | undefined,
  };

  public get displayRegister() {
    return this.isLoading ? [] : (this.register?.items ?? []).filter(isDefined);
  }

  public async loadRegister() {
    if (this.$store.state.currentOrg && this.walletId !== 'select') {
      this.isLoading = 1;
      let currencyId;
      let hasError = false;

      if (this.ticker && this.ticker !== null) {
        if (this.useFiat) {
          const fiats: Array<{ id: string; name: string; symbol: string }> = this.$store.state.fiats?.fiats ?? [];
          if (typeof fiats !== 'undefined' && Array.isArray(fiats)) {
            const fiat = fiats.find((fiat) => fiat.name === String(this.ticker).toUpperCase());
            if (fiat && fiat.id) {
              currencyId = `FIAT.${fiat.id}`;
            }
          }
        }

        if (!currencyId) {
          const assetsApiUrl = `${baConfig.addressSvcUrl}/symbols/${this.ticker}`;
          const resp = await axios.get(assetsApiUrl);
          if (resp === undefined || resp.status !== 200) {
            hasError = true;
            this.showErrorSnackbar(`Invalid ticker ${this.ticker}`);
          } else {
            currencyId = `COIN.${resp.data.coinId}`;
          }
        }
      }
      if (!hasError) {
        try {
          const res = await this.$apollo.query({
            query: RegisterQuery,
            variables: {
              orgId: this.$store.state.currentOrg.id,
              filter: {
                walletId: this.walletId,
                startDate: this.startDate === '' ? undefined : this.startDate,
                endDate: this.endDate,
                currencyId,
                page: this.currentPage,
              },
            },
          });

          // Check for GraphQL errors in the response
          if (res.errors && res.errors.length > 0) {
            const errorMessage = res.errors.map((err: any) => err.message).join(', ');
            this.showErrorSnackbar(`Failed to load register: ${errorMessage}`);
            hasError = true;
          } else if (!res.data || !res.data.register) {
            this.showErrorSnackbar('Failed to load register: No data returned');
            hasError = true;
          } else {
            this.register = res.data.register;
          }
        } catch (error: any) {
          // Handle network errors or other exceptions
          const errorMessage = error?.message || 'Unknown error occurred';
          this.showErrorSnackbar(`Failed to load register: ${errorMessage}`);
          hasError = true;
        }
      }

      this.isLoading = 0;
    }
  }

  public trans(translationKey: string): string {
    return this.$t(translationKey) as string;
  }

  public showMenuOn: Transaction | null = null;
  public expandedTxn: Transaction | null = null;
  public showCreateManualTxnModal = false;
  public ReconciliationStatus = ReconciliationStatus;
  public txnToDelete: Transaction | null = null;
  public deleteDialog = false;
  public isSoftLoading = 0;
  public walletId = 'select';
  public ticker: string | null = null;

  public get categories() {
    return this.$store.getters['categories/ENABLE_CATEGORIES'];
  }

  public get contacts(): Contact[] {
    return this.$store.getters['contacts/ENABLED_CONTACTS'];
  }

  public selectTab(tab: string) {
    this.registerTab = tab === 'register' ? RegisterTab.Register : RegisterTab.Variance;
  }

  public async refresh() {
    await Promise.all([this.$apollo.queries.register.refetch()]);

    this.$store.dispatch('categories/getCategories', this.$store.state.currentOrg.id);
    this.$store.dispatch('contacts/getContacts', this.$store.state.currentOrg.id);
    this.$store.dispatch('wallets/getWallets', this.$store.state.currentOrg.id);
  }

  toRounded(valStr: string, decimals: number) {
    const fixedString = Number(valStr).toFixed(decimals);
    return Number(fixedString);
  }

  /**
   * Pick the signed amount for a register row. `paymentAmount` is already
   * stored as a negative number for outflows, so we just take whichever side
   * has a value -- never both for a single row.
   */
  public txnAmount(txn: any): string | number | null {
    if (txn == null) return null;
    if (txn.paymentAmount != null && txn.paymentAmount !== '') return txn.paymentAmount;
    if (txn.depositAmount != null && txn.depositAmount !== '') return txn.depositAmount;
    return null;
  }

  /**
   * Format a unix-seconds timestamp for the register table and CSV, using the
   * org's preferred timezone but always including seconds. We don't reuse
   * `toPreferredDateTime` because that format ('lll z') stops at minutes.
   */
  public toRegisterDateTime(timeSEC: number): string {
    const useOrgTimezone = this.$store.state.currentOrg?.displayConfig?.useOrgTimezone ?? false;
    return formatRegisterDateTime(
      timeSEC,
      useOrgTimezone,
      this.$store.state.currentOrg?.timezone,
      'MMM D, YYYY h:mm:ss A z'
    );
  }

  /**
   * CSV-friendly variant of `toRegisterDateTime`: same data, no commas. Even
   * though the export properly RFC-4180-quotes commas, Google Sheets' default
   * "open file" path ignores quotes and splits the date across two columns.
   * Dropping the comma sidesteps that without forcing users into File > Import.
   */
  public toRegisterDateTimeCSV(timeSEC: number): string {
    const useOrgTimezone = this.$store.state.currentOrg?.displayConfig?.useOrgTimezone ?? false;
    return formatRegisterDateTime(
      timeSEC,
      useOrgTimezone,
      this.$store.state.currentOrg?.timezone,
      'YYYY-MM-DD HH:mm:ss z'
    );
  }

  /**
   * Wrap `formatCurrency` so a tiny negative value (e.g. -0.0000034) that
   * truncates to a bare '0' still shows its sign. The CSV export uses the raw
   * value so it's unaffected by this UI-only fix.
   */
  public formatBalance(value: any): string {
    const formatted = this.formatCurrency(value);
    if (value == null || value === '') return formatted;
    try {
      const bn = math.bignumber(value);
      if (bn.isNegative() && !bn.isZero() && !formatted.startsWith('-') && /^0(\.0+)?$/.test(formatted)) {
        return '-' + formatted;
      }
    } catch {
      // value isn't BigNumber-coercible -- fall through with formatted as-is
    }
    return formatted;
  }

  /**
   * Build a CSV string for an array of register items using RFC-4180 escaping.
   * Shared by the single-page Download CSV and the Full Report download so both
   * stay in lockstep when headers/columns change.
   */
  private buildRegisterCSV(items: any[]): string {
    // RFC-4180 escaping: quote any field containing comma, quote, CR, or LF,
    // and double any embedded quotes. Without this the formatted date (which
    // contains commas) splits into multiple columns and the headers no longer
    // line up with the data rows.
    const csvEscape = (v: unknown): string => {
      const s = v == null ? '' : String(v);
      return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const headers = ['Date', 'Txn', 'Ticker', 'Amount', 'Balance'];
    const csvLines: string[] = [headers.map(csvEscape).join(',')];

    items.forEach((transaction: any) => {
      const values = [
        this.toRegisterDateTimeCSV(transaction.createdSEC),
        transaction.transactionId,
        transaction.ticker,
        this.txnAmount(transaction),
        transaction.balance,
      ];
      csvLines.push(values.map(csvEscape).join(','));
    });

    return csvLines.join('\n');
  }

  /** Trigger a browser download of an in-memory CSV string. */
  private triggerCSVDownload(csv: string, filename: string): void {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  public handleDownloadReport() {
    if (!this.register) throw new Error('Unable to download register report: No register loaded');
    const csv = this.buildRegisterCSV(this.register?.items ?? []);
    this.triggerCSVDownload(csv, 'register.csv');
  }

  public onCurrencyToggle(value: boolean) {
    this.useFiat = value;
  }

  public async goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      await this.loadRegister();
    }
  }

  public async goToNextPage() {
    this.currentPage++;
    await this.loadRegister();
  }
}
